import { render } from "./Ethics.vue?vue&type=template&id=5bb6cb8b&scoped=true"
const script = {}

import "./Ethics.vue?vue&type=style&index=0&id=5bb6cb8b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bb6cb8b"]])

export default __exports__